module.exports = __webpack_public_path__ + "img/placeUsers.ee9ee6f9.svg";